"use client"

import { TriangleAlert } from "lucide-react"
import type { ReactNode } from "react"

import { cn } from "../lib/cn"
import { Button } from "./button"

type ErrorStateProps = {
  title?: ReactNode
  message?: ReactNode
  onRetry?: () => void
  icon?: ReactNode
  compact?: boolean
  className?: string
}

export function ErrorState({ title = "Something went wrong", message, onRetry, icon, compact, className }: ErrorStateProps) {
  return <div role="alert" className={cn("flex flex-col items-center justify-center text-center", compact ? "gap-2 px-4 py-6" : "gap-3 px-6 py-12", className)}><div className="text-destructive [&_svg]:size-7">{icon ?? <TriangleAlert />}</div><div className="font-semibold text-foreground">{title}</div>{message != null && <div className="max-w-[46ch] text-[12.5px] leading-relaxed text-muted-foreground">{message}</div>}{onRetry && <Button variant="ghost" size="sm" onClick={onRetry}>Retry</Button>}</div>
}
